import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e, abortMaybe as t, isSome as n } from "../../../core/maybe.js";
import { createTask as r } from "../../../core/promiseUtils.js";
import { pointEquals as a } from "../../../layers/graphics/dehydratedFeatureComparison.js";
import { EventPipeline as o } from "../dragEventPipeline.js";
import { SnappingContext as i } from "./SnappingContext.js";
import { TaskPriority as s, ImmediateTask as p } from "../../support/Scheduler.js";

var c = /*#__PURE__*/function () {
  function c() {
    _classCallCheck(this, c);

    this.next = new o();
  }

  _createClass(c, [{
    key: "createSnapDragEventPipelineStep",
    value: function createSnapDragEventPipelineStep(_ref) {
      var _this = this;

      var _ref$predicate = _ref.predicate,
          _c = _ref$predicate === void 0 ? function () {
        return !0;
      } : _ref$predicate,
          l = _ref.cancel,
          d = _ref.snappingManager,
          m = _ref.snappingContext,
          u = _ref.updatingHandles;

      if (e(d)) return function (e) {
        return e;
      };
      var x = null,
          y = null;

      var f = function f() {
        x = t(x), d.doneSnapping(), n(y) && y.frameTask.remove(), y = null;
      };

      return l.next(function (e) {
        return f(), e;
      }), this.next = new o(), function (e) {
        if (!_c(e)) return e;

        if (x = t(x), "start" === e.action) {
          var _t = "3d" === d.view.type ? d.view.resourceController.scheduler.registerTask(s.SNAPPING) : p;

          y = {
            context: new i({
              editGeometryOperations: m.editGeometryOperations,
              elevationInfo: m.elevationInfo,
              pointer: m.pointer,
              vertexHandle: n(e.info) ? e.info.handle : null,
              excludeFeature: m.excludeFeature,
              visualizer: m.visualizer
            }),
            originalPos: n(e.snapOrigin) ? m.coordinateHelper.vectorToDehydratedPoint(e.snapOrigin) : e.mapStart,
            frameTask: _t
          };
        }

        if (n(y)) {
          var _t2 = y.context.coordinateHelper.vectorToDehydratedPoint(y.context.coordinateHelper.arrayToVector([y.originalPos.x, y.originalPos.y, y.originalPos.z]));

          _t2.x += e.mapEnd.x - e.mapStart.x, _t2.y += e.mapEnd.y - e.mapStart.y;

          var _n = e.mapStart.x - y.originalPos.x,
              _o = e.mapStart.y - y.originalPos.y,
              _i = _objectSpread(_objectSpread({}, e), {}, {
            action: "udpate"
          }),
              _s = y.context,
              _p = d.update(_t2, y.context);

          if (e.mapEnd.x = _p.x + _n, e.mapEnd.y = _p.y + _o, "end" !== e.action) {
            var _e = y.frameTask;
            x = r( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r) {
                var _c2, _t3;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _e.schedule(function () {
                          return d.snap(_t2, _s, r);
                        }, r);

                      case 2:
                        _c2 = _context.sent;

                        if (!_c2.valid) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 6;
                        return _e.schedule(function () {
                          return _c2.apply();
                        }, r);

                      case 6:
                        _t3 = _context.sent;
                        a(_t3, _p) || (_i.mapEnd.x = _t3.x + _n, _i.mapEnd.y = _t3.y + _o, _this.next.execute(_i));

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()), u.addPromise(x.promise);
          }
        }

        return "end" === e.action && f(), e;
      };
    }
  }]);

  return c;
}();

export { c as SnappingPipeline };